// extracted by mini-css-extract-plugin
export default {"channel-home":"styles_channel-home__W7Osl","channel-home__empty":"styles_channel-home__empty__St0Fw"};